import * as React from 'react';
interface TableHeaderCellDataParameters<TDataType> {
    headerKey: string;
    headerValue: string | (() => JSX.Element);
    columnValue: (data: TDataType) => string | JSX.Element;
}

class TableHeaderCellData<TDataType> {
    public headerKey: string;
    public headerValue: string | (() => JSX.Element);
    public columnValue: (data: TDataType) => string | JSX.Element;

    public constructor(params: TableHeaderCellDataParameters<TDataType>) {
        this.headerKey = params.headerKey;
        this.headerValue = params.headerValue;
        this.columnValue = params.columnValue;
    }
}

export {
    TableHeaderCellDataParameters
};

export default TableHeaderCellData;